/* =============================================
   KARIYAVAR — Shopify Theme JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  // ---- ANNOUNCEMENT BAR TICKER ----
  const announcementMessages = [
    'Free Shipping On All The Available Products',
    'New Arrivals: Festive Collection Now Live',
    'Customisation Available — Contact Us',
  ];
  const announcementEl = document.querySelector('.announcement-bar p');
  if (announcementEl && announcementMessages.length > 1) {
    let idx = 0;
    setInterval(() => {
      idx = (idx + 1) % announcementMessages.length;
      announcementEl.style.opacity = '0';
      setTimeout(() => {
        announcementEl.textContent = announcementMessages[idx];
        announcementEl.style.opacity = '1';
      }, 400);
    }, 4000);
    announcementEl.style.transition = 'opacity 0.4s ease';
  }

  // ---- STICKY HEADER ----
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ---- MOBILE NAV ----
  const navToggle = document.getElementById('nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavClose = document.getElementById('mobile-nav-close');
  const overlay = document.getElementById('mobile-nav-overlay');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('active');
    overlay && overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('active');
    overlay && overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  navToggle && navToggle.addEventListener('click', openMobileNav);
  mobileNavClose && mobileNavClose.addEventListener('click', closeMobileNav);
  overlay && overlay.addEventListener('click', closeMobileNav);

  // ---- SEARCH TOGGLE ----
  const searchToggle = document.getElementById('search-toggle');
  const searchBar = document.getElementById('search-bar');
  searchToggle && searchToggle.addEventListener('click', () => {
    const isActive = searchBar.classList.toggle('active');
    if (isActive) {
      setTimeout(() => searchBar.querySelector('input').focus(), 100);
    }
  });

  // ---- HERO SLIDER ----
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.slider-dot');
  let currentSlide = 0;
  let autoplayTimer;

  function goToSlide(n) {
    slides[currentSlide] && slides[currentSlide].classList.remove('active');
    dots[currentSlide] && dots[currentSlide].classList.remove('active');
    currentSlide = (n + slides.length) % slides.length;
    slides[currentSlide] && slides[currentSlide].classList.add('active');
    dots[currentSlide] && dots[currentSlide].classList.add('active');
  }

  function startAutoplay() {
    clearInterval(autoplayTimer);
    autoplayTimer = setInterval(() => goToSlide(currentSlide + 1), 5500);
  }

  if (slides.length > 0) {
    goToSlide(0);
    startAutoplay();

    document.querySelector('.slider-btn-prev') &&
      document.querySelector('.slider-btn-prev').addEventListener('click', () => { goToSlide(currentSlide - 1); startAutoplay(); });
    document.querySelector('.slider-btn-next') &&
      document.querySelector('.slider-btn-next').addEventListener('click', () => { goToSlide(currentSlide + 1); startAutoplay(); });

    dots.forEach((dot, i) => dot.addEventListener('click', () => { goToSlide(i); startAutoplay(); }));
  }

  // ---- SIZE SELECTOR ----
  const sizeBtns = document.querySelectorAll('.size-btn');
  sizeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  // ---- SCROLL REVEAL ----
  const revealEls = document.querySelectorAll('.reveal-on-scroll');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-up');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => io.observe(el));
  }

  // ---- FILTER TOGGLE (MOBILE) ----
  const filterTitles = document.querySelectorAll('.filter-group-title');
  filterTitles.forEach(title => {
    title.addEventListener('click', () => {
      const group = title.parentElement;
      group.classList.toggle('open');
    });
  });

});

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("discount-popup");
  const closeBtn = document.getElementById("popup-close");

  if (!popup) return;

  // 👉 Show ONLY on homepage
  const isHomePage = window.location.pathname === "/";

  // 👉 If already shown OR not homepage → do nothing
  if (!isHomePage || localStorage.getItem("discountShown")) {
    return;
  }

  // 👉 Show popup after delay
  setTimeout(() => {
    popup.classList.add("active");
    localStorage.setItem("discountShown", "true");
  }, 1000);

  // 👉 Close popup
  closeBtn && closeBtn.addEventListener("click", () => {
    popup.classList.remove("active");
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const copyBtn = document.getElementById('copy-code-btn');
  const codeEl = document.getElementById('discount-code');

  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', function () {
      const code = codeEl.textContent.trim();
      const label = copyBtn.querySelector('.copy-label');

      navigator.clipboard.writeText(code).then(function () {
        const original = label.textContent;
        label.textContent = 'Copied!';
        copyBtn.classList.add('copied');
        setTimeout(function () {
          label.textContent = original;
          copyBtn.classList.remove('copied');
        }, 1800);
      }).catch(function () {
        // Fallback for older browsers
        const tmp = document.createElement('textarea');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);
        label.textContent = 'Copied!';
        setTimeout(function () { label.textContent = 'Copy'; }, 1800);
      });
    });
  }
});


// Mobile submenu accordion
document.querySelectorAll('.mobile-submenu-toggle').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.mobile-nav-item');
    item.classList.toggle('open');
  });
});

// Mobile submenu accordion
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mobile-sub-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.closest('.mobile-has-sub').classList.toggle('open');
    });
  });
});
// Product card photo slider (snippets/card-slider.liquid)
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card-slider').forEach(function (slider) {
    var slides = slider.querySelectorAll('.card-slide');
    if (slides.length < 2) return;
    var index = 0;

    function show(next) {
      slides[index].classList.remove('is-active');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    }

    slider.querySelector('.card-prev').addEventListener('click', function () { show(index - 1); });
    slider.querySelector('.card-next').addEventListener('click', function () { show(index + 1); });
  });
});
